import { Controller } from "@hotwired/stimulus"
import "emoji-picker-element"

export default class extends Controller {
  static targets = ["picker", "button"]

  connect() {
    this.pickerElement = null
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.pickerTarget.style.display === 'block') {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    // Crear el picker si no existe
    if (!this.pickerElement) {
      this.pickerElement = document.createElement('emoji-picker')
      this.pickerElement.classList.add('light')
      this.pickerElement.addEventListener('emoji-click', (event) => {
        this.insertEmoji(event.detail.unicode)
      })
      this.pickerTarget.appendChild(this.pickerElement)
    }

    this.pickerTarget.style.display = 'block'

    // Cerrar al hacer clic fuera
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick.bind(this))
    }, 100)
  }

  hide() {
    this.pickerTarget.style.display = 'none'
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  insertEmoji(emoji) {
    // Obtener el textarea visual del formulario de mensajes
    const messageForm = this.element.closest('[data-controller*="message-type"]')
    const visualTextArea = messageForm.querySelector('[data-message-type-target="visualTextArea"]')
    const hiddenTextArea = messageForm.querySelector('[data-message-type-target="textArea"]')

    if (visualTextArea) {
      // Obtener la posición actual del cursor
      const selection = window.getSelection()

      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0)

        // Si el cursor está dentro del textarea
        if (visualTextArea.contains(range.commonAncestorContainer)) {
          range.deleteContents()
          const emojiNode = document.createTextNode(emoji)
          range.insertNode(emojiNode)
          range.setStartAfter(emojiNode)
          range.collapse(true)
          selection.removeAllRanges()
          selection.addRange(range)
        } else {
          // Si no está enfocado, agregar al final
          visualTextArea.textContent += emoji
          // Colocar el cursor al final
          range.selectNodeContents(visualTextArea)
          range.collapse(false)
          selection.removeAllRanges()
          selection.addRange(range)
        }
      } else {
        // Sin selección, agregar al final
        visualTextArea.textContent += emoji
      }

      // Sincronizar con el textarea oculto
      // Trigger input event so message_type_controller handles it with line break preservation
      if (visualTextArea) {
        const inputEvent = new Event('input', { bubbles: true })
        visualTextArea.dispatchEvent(inputEvent)
      }

      // Mantener el foco en el textarea
      visualTextArea.focus()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }
}
